import styled from 'styled-components';

export const ControlPopupContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  > svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: ${({ theme }) => theme.themePrimary};
  }
`;

export const ControlPopupContent = styled.div`
  background: ${({ theme }) => theme.neutralLighter};
  border-bottom: 3px solid ${({ theme }) => theme.themePrimary};
  border-radius: 6px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.4);

  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 120px;
  overflow: hidden;
`;

export const PopupMenu = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 250px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 20px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
`;

interface PopupMenuItemProps {
  isSelected: boolean;
}

export const PopupMenuItem = styled.li<PopupMenuItemProps>`
  width: 100%;
  padding: 0.5rem 1rem;
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.themePrimary : theme.neutralLighter};
  color: ${({ isSelected, theme }) => (isSelected ? '#ffffff' : theme.black)};
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  list-style-type: none;
  white-space: nowrap;
  border-radius: 6px;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: ${({ theme }) => theme.themePrimary};
    color: #ffffff;
  }
`;

export const SwitchablePopupContainer = styled.div`
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem;

  .inputWrapper {
    display: flex;
    gap: 0.5rem;
  }
`;

export const SliderInput = styled.input`
  font-size: 14px;
  width: 50px;
  margin-right: 6px;
  border: 1px solid ${({ theme }) => theme.neutralLight};
`;
